import { Button, Form, Input, Modal } from "antd";
import { memo } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "redux/reducers/auths.slice";

const ChangePasswordModal = ({
  isShowChangePasswordModal,
  setIsShowChangePasswordModal,
}) => {
  const [form] = Form.useForm();
  const theme = localStorage.getItem("default-theme");
  const dispatch = useDispatch();

  const handleClose = () => {
    setIsShowChangePasswordModal(false);
  };

  const onFinish = async (values) => {
    const res = await dispatch(changePassword(values));

    if (res?.payload) {
      handleClose();
    }
  };

  const validatePassword = (rule, value) => {
    if (!value) return Promise.reject("Please input your password!");
    if (value.length < 8)
      return Promise.reject("Password must be at least 8 characters long");
    if (!/\d/.test(value))
      return Promise.reject("Password must contain at least one digit");
    if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(value))
      return Promise.reject(
        "Password must contain at least one special character"
      );
    return Promise.resolve();
  };

  const onFinishFailed = (errorInfo) => {
    const firstErrorField = document.querySelector(".ant-form-item-has-error");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth" });
    }
  };

  const validateConfirmPassword = (_, value) => {
    const { new_password } = form.getFieldValue();

    if (value && value !== new_password) {
      return Promise.reject(new Error("Password do not match"));
    } else {
      return Promise.resolve();
    }
  };

  return (
    <>
      <Modal
        centered
        open={isShowChangePasswordModal}
        title="Change Password"
        className={`changePasswordModal theme-${theme}`}
        maskClosable={false}
      >
        <div className="reset_password_form">
          <Form
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            scrollToFirstError
          >
            <Form.Item
              label="Old Password"
              name="old_password"
              className="mb-3 text-dark"
              rules={[
                {
                  required: true,
                  validator: validatePassword,
                },
              ]}
            >
              <Input.Password placeholder="Enter a Old Password" />
            </Form.Item>
            <Form.Item
              label="New Password"
              name="new_password"
              className="mb-3 text-dark"
              rules={[
                {
                  required: true,
                  validator: validatePassword,
                },
              ]}
            >
              <Input.Password placeholder="Enter a New Password" />
            </Form.Item>
            <Form.Item
              label="Confirm Password"
              name="confirm_password"
              className="mb-5"
              dependencies={["new_password"]}
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password!",
                  key: "confirmPasswordRequired",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    return validateConfirmPassword(_, value);
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Password" />
            </Form.Item>

            <Form.Item className="footer_btn">
              <Button className="btn_gray " onClick={handleClose}>
                Cancel
              </Button>
              <Button htmlType="ResetPassword" className="btn_primary">
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default memo(ChangePasswordModal);
